module.exports = __webpack_public_path__ + "static/media/logo-football-effects_small.490ec814.png";